import { render, staticRenderFns } from "./BookingDetailsSummary.vue?vue&type=template&id=b80ea724&scoped=true"
import script from "./BookingDetailsSummary.vue?vue&type=script&lang=ts"
export * from "./BookingDetailsSummary.vue?vue&type=script&lang=ts"
import style0 from "./BookingDetailsSummary.vue?vue&type=style&index=0&id=b80ea724&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b80ea724",
  null
  
)

export default component.exports